import { Box, Flex } from '@chakra-ui/react'
import { LuPause as Pause } from 'react-icons/lu'

// Chip "EN PAUSA" (ámbar) para listas/tablas. La pausa es un evento, no un estado:
// el traslado sigue EnTransito, por eso se muestra junto al estado, no en su lugar.
// El motivo va como tooltip nativo (title) para no saturar la fila.
export function PauseBadge({ reason, size = 'sm' }: { reason?: string | null; size?: 'sm' | 'xs' }) {
  const fontSize = size === 'xs' ? '9px' : '10px'
  const label = reason ? `En pausa: ${reason}` : 'En pausa'
  return (
    <Box title={label} display="inline-flex">
      <Flex
        alignItems="center"
        gap={1}
        px={2}
        py={0.5}
        borderRadius="full"
        bg="#d49a2a22"
        color="#8a5f0b"
        border="1px solid"
        borderColor="#d49a2a55"
        fontSize={fontSize}
        fontWeight="700"
        textTransform="uppercase"
        letterSpacing="0.06em"
        whiteSpace="nowrap"
      >
        <Pause size={size === 'xs' ? 9 : 10} fill="#8a5f0b" />
        En pausa
      </Flex>
    </Box>
  )
}
